/**
 * Avise-me (Klaviyo): URL/variante no modal + conversão RD via formulário-ponte na página.
 * O RD não enxerga o iframe do Klaviyo; o envio usa o form #sem-costura-rd-bis-bridge.
 */
(function () {
  if (!window.location.pathname.includes('/products/')) return;

  const FIELD_URL = 'product_url';
  const FIELD_VARIANT = 'variant_id';
  const BRIDGE_FORM_ID = 'sem-costura-rd-bis-bridge';

  function getRdConfig() {
    return window.SemCosturaRdBis || {};
  }

  function getVariantIdFromPage() {
    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    if (urlVariant) return urlVariant;

    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], .product-variant-id'
    );
    return variantInput?.value || '';
  }

  function buildProductUrl(variantId) {
    const url = new URL(window.location.origin + window.location.pathname);
    if (variantId) url.searchParams.set('variant', variantId);
    return url.toString();
  }

  function getProductUrlWithVariant(variantId) {
    const id = variantId || getVariantIdFromPage();
    return buildProductUrl(id);
  }

  function getProductTitle() {
    return (
      document.querySelector('.product__title h1, .product__title .h1')?.textContent?.trim() || ''
    );
  }

  function getBisDocument() {
    const iframe = document.getElementById('klaviyo-bis-iframe');
    if (!iframe) return null;
    return iframe.contentDocument || iframe.contentWindow?.document || null;
  }

  function getBisForm() {
    const doc = getBisDocument();
    if (!doc) return null;
    const modal = doc.getElementById('klaviyo-bis-modal');
    return modal?.querySelector('form') || null;
  }

  function getBridgeForm() {
    return document.getElementById(BRIDGE_FORM_ID);
  }

  function isElementVisible(el) {
    if (!el) return false;
    const view = el.ownerDocument.defaultView;
    if (!view) return false;
    const style = view.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetHeight > 0;
  }

  function setHiddenValue(form, name, value) {
    const doc = form.ownerDocument;
    let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
    if (!input) {
      input = doc.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function setBridgeField(bridge, name, value) {
    const input = bridge.querySelector(`[name="${name}"]`);
    if (input) input.value = value || '';
  }

  function syncHiddenFields(form, variantId) {
    const id = variantId || getVariantIdFromPage();
    setHiddenValue(form, FIELD_URL, getProductUrlWithVariant(id));
    setHiddenValue(form, FIELD_VARIANT, id);
  }

  /** Token público que o próprio script do RD costuma injetar em outros formulários. */
  function getRdPublicToken() {
    const onPage = document.querySelector('input[name="token_rdstation"]');
    if (onPage?.value) return onPage.value;

    if (window.RdIntegration?.token) return window.RdIntegration.token;

    return null;
  }

  function ensureBridgeToken(bridge) {
    const token = getRdPublicToken();
    if (!token) return;

    let tokenInput = bridge.querySelector('input[name="token_rdstation"]');
    if (!tokenInput) {
      tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'token_rdstation';
      bridge.appendChild(tokenInput);
    }
    tokenInput.value = token;
  }

  function buildBridgePayload(bridge, { email, productUrl, variantId }) {
    const config = getRdConfig();

    setBridgeField(bridge, 'email', email);
    setBridgeField(bridge, 'nome', getProductTitle());
    setBridgeField(
      bridge,
      'identificador',
      config.conversionIdentifier || 'Avise-me - Produto esgotado'
    );
    setBridgeField(bridge, config.cfProductUrl || 'cf_url_produto', productUrl);
    setBridgeField(bridge, config.cfVariantId || 'cf_variant_id', variantId);

    ensureBridgeToken(bridge);
  }

  function submitViaLegacyApi(bridge) {
    const body = new URLSearchParams(new FormData(bridge));

    return fetch('https://www.rdstation.com.br/api/1.3/conversions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    }).then((response) => {
      if (!response.ok) {
        return response.text().then((text) => {
          throw new Error(text || `HTTP ${response.status}`);
        });
      }
    });
  }

  function submitBridgeInHiddenFrame(bridge) {
    let targetFrame = document.getElementById('sem-costura-rd-submit-frame');
    if (!targetFrame) {
      targetFrame = document.createElement('iframe');
      targetFrame.id = 'sem-costura-rd-submit-frame';
      targetFrame.name = 'sem-costura-rd-submit-frame';
      targetFrame.title = 'RD Station';
      targetFrame.style.cssText =
        'position:absolute;width:0;height:0;border:0;visibility:hidden;pointer-events:none';
      targetFrame.setAttribute('aria-hidden', 'true');
      document.body.appendChild(targetFrame);
    }

    const previousTarget = bridge.getAttribute('target');
    bridge.setAttribute('target', 'sem-costura-rd-submit-frame');

    if (typeof bridge.requestSubmit === 'function') {
      bridge.requestSubmit();
    } else {
      bridge.submit();
    }

    if (previousTarget) {
      bridge.setAttribute('target', previousTarget);
    } else {
      bridge.removeAttribute('target');
    }
  }

  function sendToRdStation({ email, productUrl, variantId }) {
    const config = getRdConfig();
    if (config.enabled === false) return Promise.resolve();

    const bridge = getBridgeForm();
    if (!bridge) {
      console.warn('[BIS→RD] Formulário-ponte não encontrado na página.');
      return Promise.resolve();
    }

    buildBridgePayload(bridge, { email, productUrl, variantId });

    if (typeof window.RdIntegration !== 'undefined') {
      if (typeof window.RdIntegration.post === 'function') {
        try {
          window.RdIntegration.post({
            identifier: config.conversionIdentifier || 'Avise-me - Produto esgotado',
            email,
            [config.cfProductUrl || 'cf_url_produto']: productUrl,
            [config.cfVariantId || 'cf_variant_id']: variantId,
          });
          return Promise.resolve();
        } catch (error) {
          console.warn('[BIS→RD] RdIntegration.post falhou, tentando formulário-ponte.', error);
        }
      }
    }

    ensureBridgeToken(bridge);
    const token = getRdPublicToken();

    if (token) {
      return submitViaLegacyApi(bridge).catch((error) => {
        console.warn('[BIS→RD] API 1.3:', error.message || error);
        submitBridgeInHiddenFrame(bridge);
      });
    }

    submitBridgeInHiddenFrame(bridge);
    return Promise.resolve();
  }

  function submitRdConversion(form) {
    if (form.dataset.rdConversionSent === 'true') return;

    const emailInput = form.querySelector('#email, input[type="email"]');
    const email = emailInput?.value?.trim();
    if (!email) return;

    const variantSelect = form.querySelector('select');
    const variantId = variantSelect?.value || getVariantIdFromPage();
    const productUrl = getProductUrlWithVariant(variantId);

    form.dataset.rdConversionSent = 'true';

    sendToRdStation({ email, productUrl, variantId }).catch((error) => {
      form.dataset.rdConversionSent = 'false';
      console.error('[BIS→RD] Erro ao enviar conversão:', error);
    });
  }

  function watchBisSuccess(form) {
    const successEl = form.querySelector('#completed_message');
    if (!successEl || successEl.dataset.rdWatcher === 'true') return;

    successEl.dataset.rdWatcher = 'true';

    const observer = new MutationObserver(() => {
      if (isElementVisible(successEl)) submitRdConversion(form);
    });

    observer.observe(successEl, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      childList: true,
      subtree: true,
    });
  }

  function setupBisForm(form) {
    if (form.dataset.productUrlFieldsReady === 'true') return;
    form.dataset.productUrlFieldsReady = 'true';

    syncHiddenFields(form);
    watchBisSuccess(form);

    const variantSelect = form.querySelector('select');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        syncHiddenFields(form, variantSelect.value);
      });
    }

    form.addEventListener(
      'submit',
      () => {
        const variantId = variantSelect?.value || getVariantIdFromPage();
        syncHiddenFields(form, variantId);

        let attempts = 0;
        const pollSuccess = setInterval(() => {
          attempts += 1;
          const successEl = form.querySelector('#completed_message');
          if (isElementVisible(successEl)) {
            clearInterval(pollSuccess);
            submitRdConversion(form);
          } else if (attempts >= 24) {
            clearInterval(pollSuccess);
          }
        }, 500);
      },
      true
    );
  }

  function trySetupBisForm() {
    const form = getBisForm();
    if (form) setupBisForm(form);
  }

  function onPageVariantChange() {
    const form = getBisForm();
    if (form) syncHiddenFields(form);
  }

  function watchBisIframe() {
    const observer = new MutationObserver(() => {
      const iframe = document.getElementById('klaviyo-bis-iframe');
      if (!iframe || iframe.dataset.productUrlWatcher === 'true') return;

      iframe.dataset.productUrlWatcher = 'true';

      const runSetup = () => {
        trySetupBisForm();
        setTimeout(trySetupBisForm, 150);
        setTimeout(trySetupBisForm, 500);
      };

      iframe.addEventListener('load', runSetup);
      runSetup();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  const originalReplaceState = history.replaceState;
  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    onPageVariantChange();
  };

  window.addEventListener('popstate', onPageVariantChange);

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onPageVariantChange);
    }
  });

  watchBisIframe();
})();
